<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" lg="5" md="6">
        <v-card>
          <v-card-title>
            {{ $t("me.pages.validation_token.title") }}
          </v-card-title>
          <v-card-text v-if="verified">
            <div v-show="task === 'collect_publication'">
              {{ $t("me.pages.validation_token.collect_publication") }}
            </div>
          </v-card-text>
          <v-card-text v-else>
            {{ $t("me.pages.validation_token.invalid_token") }}
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "ValidationToken",
  data: () => ({
    verified: false,
    task: "",
  }),
  mounted() {
    this.verification()
  },
  computed: {
    token() {
      return this.$route.params.token
    },
  },
  methods: {
    verification() {
      this.$axios
        .post("office/me/publications/validate/by/token", {
          token: this.token,
        })
        .then(response => {
          this.verified = true
          this.$i18n.locale = response.data.data.locale
          this.task = response.data.data.task
        })
    },
  },
}
</script>
